<template>
  <div>
    <vue-headful
    title="Dashboard | Billing"
    description="Dashboard | Billing"
/>

<div v-if="loading" style="margin: 100px auto;">
  <center>
  <lottie-player src="https://logo.app/lottie/logo-design-loading.json" background="transparent" speed="1" style="width:100%; height:100%; max-width: 500px; max-height: 500px;" loop autoplay></lottie-player>
  <p class="lead">Loading...</p>
  </center>
</div>


    <div v-if="!loading" class="sc-kEYyzF grKTOC">
       <div class="sc-kAdXeD jwoEpG" style="padding: 0px 0px 30px 0px!important">
          <div class="sc-bvTASY jPMoWD">
             <div class="sc-cFlXAS WflZx">
                <div style="position: relative;">

                <div>
                       <div class="card border-light shadow-soft" style="margin-bottom:20px;margin: 0 auto;padding: 10px;border-left: .0625rem solid rgba(243,247,250,.05); border-right: .0625rem solid rgba(243,247,250,.05); border-bottom: .0625rem solid rgba(243,247,250,.05); border-top: 0; border-radius: 0 0 .5rem .5rem;">
                          <div class="card-body p-4 p-lg-3">
                             <div class="col-12">
                               <!-- UPDATE CARD -->
                               <div v-if="(propsdata[0].paid === 'yes' || propsdata[0].canceled === 'yes' || propsdata[0].canceled_due_attempt2 === 'yes') && cards !== 'no card'">
                               <h4 style="margin-bottom: 1rem;">Payment Method</h4>
                               <!-- <p v-if="cards[0].expiring_card === 'yes'" style="color:#ff0000;">Just a quick heads up: your card is set to expire in a month. Update it as soon as possible.</p>
                               <p v-if="cards[0].expired_card === 'yes'" style="color:#ff0000;">Your card expired. Update it today in order to keep your logo.app account active.</p> -->
                               <div class="row">
                               <div class="col-auto">
                               <img v-if="cards[0].brand.toLowerCase() === 'mastercard'" src="https://logo.app/assets/img/mastercard.jpg" style="width: 80px;">
                               <img v-else-if="cards[0].brand.toLowerCase() === 'visa'" src="https://logo.app/assets/img/visa.jpg" style="width: 80px;">
                               <img v-else-if="cards[0].brand.toLowerCase() === 'american express'" src="https://logo.app/assets/img/amex.jpg" style="width: 80px;">
                               <img v-else-if="cards[0].brand.toLowerCase() === 'discover'" src="https://logo.app/assets/img/discover.jpg" style="width: 80px;">
                               <img v-else src="https://logo.app/assets/img/cc_placeholder.png" style="width: 80px;">
                               </div>
                               <div class="col-auto">
                               <p style="margin-bottom: 0;"><strong>{{cards[0].brand}} **** {{cards[0].last4}}</strong></p>
                               <p style="margin-bottom: 0;">Expires <strong>{{cards[0].expiration_date}}</strong></p>
                               </div>
                               </div>
                               <!-- <a class="btn btn-secondary mt-4 animate-up-2" href=""><i class="fas fa-pen"></i> Update Card</a> -->
                               <hr>
                               </div>
                              <!-- SHOW INVOICES -->
                              <div v-if="invoices !== null">
                                <div class="col-md-12 row m-0 p-0">
                                  <h4 style="margin-bottom: 1rem;" class="col-md-9 p-0">Invoices</h4>
                                  <router-link class="btn btn-success animate-up-2 mb-3 col-md-3" to="/dashboard/edit-billing">Edit Billing Information <i class="fas fa-arrow-right"></i></router-link>
                                </div>
                                <ul class="list-group">
                                  <li v-for="(invoice, num) in invoices" class="list-group-item border-bottom" style="border: 1px solid #e1e1e1!important;">
                                    <div class="row align-items-center">
                                      <div class="col">
                                        <h3 class="h6 mb-1">
                                          <a :href="'https://logo.app/invoice/'+invoice.unique_id" target="_blank">Invoice #{{invoice.unique_id}}</a>
                                        </h3>
                                        <small class="text-gray-700">Billed {{invoice.date}}</small>
                                      </div>
                                      <div class="col-md-auto mt-2 mt-md-0">
                                        <a :href="'https://logo.app/invoice/'+invoice.unique_id" target="_blank" class="btn btn-primary animate-up-2 w-100"><i class="fas fa-download"></i> Download</a>
                                      </div>
                                    </div>
                                  </li>
                                </ul>
                               </div>
                               <div v-else-if="propsdata[0].paid !== 'yes' && propsdata[0].canceled_due_attempt2 !== 'yes' && propsdata[0].canceled !== 'yes'">
                                 <h4 class="mb-0">You need to upgrade your account to edit your billing information and download your invoices/receipts.</h4>
                               </div>
                               <div v-if="propsdata[0].paid === 'yes' || propsdata[0].canceled_due_attempt2 === 'yes' || propsdata[0].canceled === 'yes'">
                                <div v-if="!moreinformation" @click="moreinformation = true" style="text-decoration:underline;cursor:pointer;" class="col-12 mt-4 mb-4">See more <i class="fas fa-caret-down"></i></div>
                                <div v-if="moreinformation" @click="moreinformation = false" style="text-decoration:underline;cursor:pointer;" class="col-12 mt-4 mb-4">See less <i class="fas fa-caret-up"></i></div>
                                <div v-if="moreinformation">
                                  <div class="col-12">
                                    <div v-if="propsdata[0].paid === 'yes' && propsdata[0].cancel_at_period_end !== 'yes' && propsdata[0].canceled !== 'yes'">
                                        <div>
                                          <h4>Cancel Subscription</h4>
                                          <p>You can cancel your subscription whenever you want.</p>
                                          <div class="alert alert-danger alert-dismissible fade show" role="alert">
                                            <span class="alert-inner--icon"><i class="fas fa-exclamation-circle"></i></span>
                                            <span class="alert-inner--text"><strong>Note:</strong> You will lose all access and ownership of your logos, including all the premium features.</span>
                                          </div>
                                          <a data-toggle="modal" data-target="#modal-cancel" style="text-decoration: underline;color:#ff0000">Cancel Subscription</a>
                                        </div>
                                    </div>
                                    <div v-else-if="(propsdata[0].paid === 'yes' && propsdata[0].cancel_at_period_end === 'yes') || propsdata[0].canceled === 'yes'">
                                      <hr>
                                      <h4>Subscription Canceled</h4>
                                      <p>You can subscribe again anytime by clicking the button below.</p>
                                      <a :href="'/payment/sub/'+propsdata[0].unique_id" class="btn btn-success animate-up-2">Subscribe Again</a>
                                    </div>
                                  </div>
                                </div>
                               </div>
                               </div>
                            </div>
                          </div>

                  </div>

             </div>
          </div>
       </div>
    </div>

    <!-- MODAL CANCEL -->
    <div class="modal fade" id="modal-cancel" tabindex="-1" role="dialog" aria-labelledby="modal-cancel" aria-hidden="true">
       <div class="modal-dialog modal-dialog-centered" role="document">
           <div class="modal-content">
               <div class="modal-header">
                   <h6 class="modal-title">Do you really want to cancel your subscription?</h6>
                   <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                       <span aria-hidden="true">&times;</span>
                   </button>
               </div>
               <div class="modal-body">
                <div class="alert alert-danger alert-dismissible fade show mb-0" role="alert">
                  <span class="alert-inner--icon"><i class="fas fa-exclamation-circle"></i></span>
                  <span class="alert-inner--text"><strong>Note:</strong> You will lose all access and ownership of your logos, including all the premium features.</span>
                </div>
               </div>
               <div class="modal-footer">
                   <a href="/dashboard/cancel-reasons" class="btn btn-sm btn-success">Yes, I want to cancel my subscription.</a>
                   <button type="button" class="btn btn-link text-danger ml-auto" data-dismiss="modal">Close</button>
               </div>
           </div>
       </div>
   </div>

 </div>

</div>

</template>

  <script>
  import ClickOutside from 'vue-click-outside';

  export default {
    props:['propsdata'],
    data() {
      return {
        loading: true,
        billing: [],
        cards: [],
        invoices: [],
        moreinformation: false
      };
    },
    methods: {
      cargarcards(){
        //CARGAR CARDS
        axios.post('/dashboard/cargar-cards.php', {
          })
          .then(response => {
            this.cards = response.data;
            this.cargarinvoices();
        })
          .catch(function (error) {
            console.log(error);
          });
      },
      cargarinvoices(){
        //CARGAR INVOICES
        axios.post('/dashboard/cargar-invoices.php', {
          })
          .then(response => {
            this.invoices = response.data;
            this.loading = false;
        })
          .catch(function (error) {
            console.log(error);
          });
      }
    },
    mounted() {
      this.$emit('updateprops');
      this.cargarcards(); //METHOD cargarinvoices EXECUTES AFTER cargarcards HAS A RESPOND
    },
    // do not forget this section
directives: {
  ClickOutside
}
  };
  </script>



// WEBPACK FOOTER //
// src/billing.vue